import React, { useState } from 'react';
import useSendSMS from '../hooks/useSendSMS';

const SendSMS = () => {
    const [transactionId, setTransactionId] = useState('0001375393384');
    const [messageBody, setMessageBody] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    
    const { sendSMS, response, error } = useSendSMS(); // Call the custom hook

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Call the sendSMS function when form is submitted
        await sendSMS(transactionId, messageBody, mobileNumber);
    };

    return (
        <div>
            <h1>Send SMS</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Transaction ID:</label>
                    <input
                        type="text"
                        value={transactionId}
                        onChange={(e) => setTransactionId(e.target.value)}
                    />
                </div>
                <div>
                    <label>Message Body:</label>
                    <textarea
                        value={messageBody}
                        onChange={(e) => setMessageBody(e.target.value)}
                    />
                </div>
                <div>
                    <label>Mobile Number:</label>
                    <input
                        type="text"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value)}
                    />
                </div>
                <button type="submit">Send SMS</button>
            </form>

            {response && (
                <div>
                    <h2>Response:</h2>
                    <pre>{JSON.stringify(response, null, 2)}</pre>
                </div>
            )}

            {error && (
                <div style={{ color: 'red' }}>
                    <h2>Error:</h2>
                    <pre>{JSON.stringify(error, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default SendSMS;
